import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import styled from 'styled-components';

import { ModalTitleSC } from '@hilbi/web-common/components/modal/modal.styled';

import SvgAddStaffCheck from '@assets/svg/my-profile/icon-success-check.svg';
import Button from '@components/button';
import Modal from '@components/modal';
import { memberApiV2 } from '@lib/api';
import TStore from 'types/store';
import { StyledForm } from '../../../../profile/components/Account/FormStyles.styled';

export type TFormValues = {
  role: string;
};

const StyledModal = styled.div`
  .image-wrapper {
    img {
      display: block;
      margin: 0 auto;
    }
  }

  span {
    display: block;
    margin: 12px auto 12px auto;

    font-weight: 300;
    font-size: 25px;
    line-height: 37px;

    text-align: center;

    color: #333d6c;
  }
`;

type TProps = {
  id: string;
  onRequestClose: () => void;
};

const ApproveStaffModal: React.FC<TProps> = ({ id, onRequestClose }) => {
  const { formatMessage } = useIntl();

  const providerId = useSelector((state: TStore) => state.users.business[0].id);

  const [displaySuccessMessage, setDisplaySuccessMessage] = useState(false);
  const [role, setRole] = useState<{ label: string; value: string }>();
  const [submitLoading, setSubmitLoading] = useState(false);

  // Load available roles
  const { isLoading, data } = useQuery(['business-roles', providerId], async () => {
    const { data } = await memberApiV2.getRoles(providerId as string);
    return data.data;
  });

  const handleConfirmBtnClick = async () => {
    setSubmitLoading(true);
    console.log('RR', role);
    try {
      await memberApiV2.changeStateStaff(providerId, id);
      // @ts-expect-error
      await memberApiV2.changeRoleStaff(providerId, id, role.value);
      setDisplaySuccessMessage(true);
    } catch (err) {
      console.error('Some nasty err happened', err);
    } finally {
      setSubmitLoading(false);
    }
  };

  if (isLoading) {
    return null;
  }

  return (
    <Modal showClose isOpen={true} onRequestClose={onRequestClose}>
      {displaySuccessMessage && (
        <StyledModal>
          <div className="image-wrapper">
            <img src={SvgAddStaffCheck} alt="success" />
          </div>
          <span>
            {formatMessage({
              id: 'staff_modal_approve_success',
            })}
          </span>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', paddingTop: 24 }}>
            <Button
              style={{ width: '100%', maxWidth: '100%' }}
              text="continue_btn_label"
              kind="PRIMARY"
              onClick={onRequestClose}
            />
          </div>
        </StyledModal>
      )}

      {!displaySuccessMessage && (
        <>
          <ModalTitleSC style={{ textAlign: 'left', marginBottom: 24 }}>
            <FormattedMessage id={'staff_modal_approve_heading'} />
          </ModalTitleSC>
          <form>
            <StyledForm>
              <Select
                id="role"
                name="role"
                placeholder="Pick a role" // TODO translate
                // value={{
                //   label: formatMessage({ id: `business_staff_role_${role.label}` }),
                //   value: role.value,
                // }}
                onChange={(selectedOpt: any) => setRole(selectedOpt)}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                menuPortalTarget={document.body}
                options={data.map((item: any) => ({
                  value: item.id,
                  label: formatMessage({ id: `business_staff_role_${item.name}` }),
                }))}
              />
            </StyledForm>
          </form>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', paddingTop: 24 }}>
            <Button
              style={{ width: '100%', maxWidth: '100%', marginRight: 16 }}
              text={formatMessage({ id: 'table_context_menu_close' })}
              kind="SECONDARY"
              onClick={onRequestClose}
            />
            <Button
              style={{ width: '100%', maxWidth: '100%' }}
              text="continue_btn_label"
              kind="PRIMARY"
              onClick={handleConfirmBtnClick}
            />
          </div>
        </>
      )}
    </Modal>
  );
};

export default ApproveStaffModal;
